import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { Drawer, Form, Row, Col ,Button, Space} from "antd"
import { actionsApi} from "../../../shared"
import { ApiCalls } from "../../../shared/ApiCalls"
import { methodAllow, methodUrlType, yesNo } from "../../../shared/lookups"
import Portals from "./Portals"
import { MyInput, MySelect } from "../../Forms"
import { useTranslation } from "react-i18next"

const AddEditBoxDrawer = ({visible, onClose, editbox, getAllApplications }) => {
    
    const dispatch= useDispatch()
    const [form] = Form.useForm()
    const [ loading, setLoading ] = useState(false)
    const { t } = useTranslation()
  
    useEffect(() => {
        if (visible && editbox) {
            getBoxDetails(editbox)
            dispatch(actionsApi?.getPortals(editbox))
        }
        else 
            form.resetFields()
    }, [visible, editbox])

    const getBoxDetails = async (id) => {
        let result= await ApiCalls?.AddEditBoxApi?.getBoxDetails(id)
        if(result)
         form.setFieldsValue({
             ...result,
             masterPortal: 1,
             updateUrl: parseInt(result?.updateUrl),
         })
    }

    const onFinish = async () => {
        try {
            let formData= await form.validateFields()
            formData= {
                ...formData,
                androidBoxAddedFor: 1,
                portals: formData?.portals?.map((portal, index)=> {
                    const urlTypeId = methodUrlType?.find(fin=> fin?.name === portal?.urlType)?.id || portal?.urlType;
                    portal={
                        ...portal, 
                        selectUrl: index +1, 
                        isLock: portal?.isLock ? 1 : 0,
                        urlType: urlTypeId,
                        methodType: urlTypeId
                    }
                    if(portal?.urlType !== 3){
                        delete portal?.userName 
                        delete portal?.password
                    }
                    delete portal?.urlNo
                    return portal
                })
            }
            console.log("Gönderilen veri:", formData)
            setLoading(true)
            const result = await ApiCalls.AddEditBoxApi.updateCreateApi({...formData, id: editbox});
            setLoading(false)
            if(result){
                closeDrawer()
                getAllApplications()
            }
        } catch (error) {
            console.error("Form validation error:", error);
        }
    }
    const closeDrawer= ()=>{
        dispatch(actionsApi?.clearPortalsResponse())
        form.resetFields()
        onClose()
    }

  return (
    <div>
        <Drawer
            title={editbox ? t('Edit Box') : t('Add Box')}
            onClose={closeDrawer}
            open={visible}
            width={800}
            footer={
                <Space className="w-100">
                    <Button 
                        onClick={closeDrawer}
                    >
                        {t('Cancel')}
                    </Button>
                    <Button  
                        block
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        onClick={()=> form.submit()}
                    >
                        {editbox ? t('Update box') : t('Save')}
                    </Button>
                </Space>
            }
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={true}
                onFinish={onFinish}
            >
                <Row gutter={16}  >
                    <Col lg={{span: 12}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                        <MyInput
                            autoFocus
                            label={t('Android box name')}
                            name='boxName'
                            placeholder={t('e.g Box1001')}
                            required
                            message={t('please enter android box name')}
                            value={form.getFieldValue("boxName") || ''} 
                        />
                    </Col>
                    <Col lg={{span: 12}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                        <MyInput
                            label={t('Serial number')}
                            name='serialNo'
                            placeholder={t('e.g 1234')}
                            required
                            message={t('please enter serial number')}
                        />
                    </Col>
                    <Col lg={{span: 12}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                        <MySelect
                            label={t('Master Portal')}
                            name="masterPortal" 
                            placeholder={t('select master portal')}
                            options={yesNo}
                        />
                    </Col>
                    <Col lg={{span: 12}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                        <MyInput
                            label={t('Mac Address')}
                            name='macAddress'
                            placeholder={t('e.g 00:B0:D0:63:C2:46')}
                            required
                            message={t('please enter mac address')}
                            onChange={(e) => {
                                const inputValue = e.target.value;
                                const cleanedValue = inputValue.replace(/\W/g, '');
                                const formattedMacAddress = cleanedValue.match(/.{1,2}/g)?.join(':').slice(0, 17) || '';
                                form.setFieldsValue({ ...form?.getFieldsValue(), macAddress: formattedMacAddress });
                            }} 
                        />
                    </Col>
                    <Col lg={{span: 12}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                        <MySelect
                            label={t('Update Url')}
                            name="updateUrl" 
                            required
                            message={t('please choose update url')}
                            placeholder={t('Choose updated url')}
                            options={methodAllow}
                        />
                    </Col>
                    <Col lg={{span: 12}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                        <MyInput
                            label={t('Customer Name')}
                            name='customerName'
                            placeholder={t('e.g John Doe')}
                            required
                            message={t('Please enter customer name')}
                            value={form.getFieldValue("customerName") || ''}
                        />
                    </Col>
                    <Col span={24}>
                        <Portals {...{form}}/>
                    </Col>
                </Row>
            </Form>
        </Drawer>
    </div>
  )
}

export {AddEditBoxDrawer}